import {CALL_API} from 'middleware/api';

import * as ActionTypes from '../Cashout';

function fetchCreateCashout(data) {
    const {betId, stakeId, amount} = data;
    return {
        type: ActionTypes.CREATE_CASHOUT,
        [CALL_API]: {
            endpoint: `/api/bet/${betId}/stake/${stakeId}/cashout?amount=${amount}`,
            method: 'post',
            types: [
                ActionTypes.SUCCESS_CREATE_CASHOUT,
                ActionTypes.FAILURE_CREATE_CASHOUT
            ],
            credentials: true,
            data
        }
    };
}

export function createCashout(data) {
    return (dispatch) => {
        return dispatch(fetchCreateCashout(data));
    };
}

export function setCashoutStatus(data) {
    return {type: ActionTypes.SET_CASHOUT_STATUS, data};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Cashout.js